import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import './treatment.scss';

import $ from 'jquery';
import 'slick-carousel';

$(() => {
  $('.overviewslider01').slick({
    autoplay: true,
    arrows: true,
    dots: true,
    infinite: true,
    speed: 1000,
    fade: true,
  });
  $('.overviewslider02').slick({
    autoplay: true,
    arrows: true,
    dots: true,
    infinite: true,
    speed: 1000,
    fade: true,
  });
  $('.overviewslider03').slick({
    autoplay: true,
    arrows: true,
    dots: true,
    infinite: true,
    speed: 1000,
    fade: true,
  });
});

// Find the button with the question
const question = document.getElementsByClassName('question'),
  answer = document.getElementsByClassName('answer');

for (let i = 0; i < question.length; i++) {
  question[i].addEventListener('click', () => {
    answer[i].style.display =
      answer[i].style.display == 'flex' ? 'none' : 'flex';
    answer[i].classList.toggle('is-active');
    question[i].classList.toggle('is-active');
  });
}
